// extracted by mini-css-extract-plugin
export default {"container":"InputLabel--container--7aa928","required":"InputLabel--required--3e9ee2","fullBorder":"InputLabel--fullBorder--a6647b"};